document.addEventListener("scroll", function() {
    const divs = document.querySelectorAll(".section_affiliate");
    
    if (divs) {
        divs.forEach(div => {
            const rect = div.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;

            // Calcula si el centro del div está cerca del centro de la pantalla
            const divCenter = rect.top + rect.height / 2;
            const screenCenter = windowHeight / 2;

            if (Math.abs(divCenter - screenCenter) <= rect.height / 2) {
                div.classList.add("show");
            } else {
                div.classList.remove("show");
            }
        });
    }
});
